import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, LocateFixed } from "lucide-react";
import { usePrefs } from "@/contexts/PrefsContext";

export const LocateMeButton = ({ onPick }: { onPick: (lat: number, lng: number) => void }) => {
  const { t } = usePrefs();
  const [busy, setBusy] = useState(false);
  const locate = () => {
    if (!navigator.geolocation) return toast.error(t("edit.gpsUnsupported"));
    setBusy(true);
    navigator.geolocation.getCurrentPosition((pos) => {
      setBusy(false);
      onPick(+pos.coords.latitude.toFixed(6), +pos.coords.longitude.toFixed(6));
      toast.success(t("lm.done"));
    }, (err) => {
      setBusy(false);
      toast.error(t(err.code === 1 ? "edit.gpsDenied" : "edit.gpsFailed"));
    }, { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 });
  };
  return (
    <button type="button" onClick={locate} disabled={busy} data-testid="spot-use-my-location"
      className="w-full h-11 rounded-full bg-foreground text-background text-sm font-bold inline-flex items-center justify-center gap-2 active:scale-[0.98] transition-transform disabled:opacity-60">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <LocateFixed className="h-4 w-4" />}
      {t(busy ? "lm.locating" : "lm.button")}
    </button>
  );
};
